// import Loader from "../loader/Loader";
import Loader from "./Loader";
// import Loader from "./Loader";
const NoResultFoundModel = ({ name, totalRecords }) => {
  return (
    <div className="noResult">
      <div className="text-center">
        {totalRecords === -1 ? (
          <h5 className="text-center py-4 text-gray-700 mt-4">
            {/* <Loader /> */}
            No Data Found
          </h5>
        ) : (
          <h5 className="mt-4 text-center">No Data Found</h5>
        )}
      </div>
    </div>
  );
};
export default NoResultFoundModel;
